import gql from 'graphql-tag';

export default gql`
  query HydrationDay($date: Date!) {
    me {
      id
      hydrationSettings {
        key
        defaultDailyGoal {
          value
          unit
        }
      }
      hydrationDay(date: $date) {
        key
        goal {
          value
          unit
        }
        value {
          value
          unit
        }
        portions {
          id
          value {
            value
            unit
          }
        }
      }
    }
  }
`;
